import { Component } from "vue";

export default [
  { path: "", redirect: { name: "myInvestmentsList" }, name: "myInvestments" },
  {
    path: "list",
    component: (): Promise<Component> =>
      import("../components/MyInvestmentsList.vue"),
    name: "myInvestmentsList",
  },
  {
    path: "sale/:uuid",
    component: (): Promise<Component> =>
      import("../components/SaleInvestment.vue"),
    name: "saleInvestment",
  },
  {
    path: "sale/:uuid/confirmation/:confirmationUuid",
    component: (): Promise<Component> =>
      import("../components/SaleConfirmation.vue"),
    name: "saleConfirmation",
  },
];
